// Initial state for customer form data
export const initialCustomerFormData = {
  customerName: "",
  customerNumber: "",
  thirdPartyControlNumber: "",
  managementID: "",
  statusID: "Active",
  dispatchType: "",
  dispatchingStatus: "",
  customerClass: "",
  customerSince: "",
  websiteAddress: "",
  emailAddress: "",
  creditLimit: "",
  paymentRating: "",
  averageDaysToPay: "",
  averageDaysToPayLastYear: "",
  averageDaysToPayLast: "",
  billingCode: "",
  billingClass: "",
  taxDetailID: "",
  salesID: "",
  salesIndexService: "",
  salesIndexProposal: "",
  salesIndexMaintenance: "",
  salesIndexParts: "",
  customerNote: "",
  paymentID: "",
  addressCareOf: "",
  address: "",
  addressTwo: "",
  city: "",
  state: "",
  zip: "",
  billingAddressCareOf: "",
  billingAddress: "",
  billingAddressTwo: "",
  billingCity: "",
  billingState: "",
  billingZip: "",
};

export const customerListFields = [
  { key: "customerName", label: "Name", type: "text" },
  { key: "managementID", label: "Management Company", type: "text" },
  {
    key: "statusID",
    label: "Status",
  },
  { key: "addressCareOf", label: "Address Care Of", type: "text" },
  { key: "address", label: "Address Line 1", type: "text" },
  { key: "addressTwo", label: "Address Line 2", type: "text" },
  { key: "city", label: "City", type: "text" },
  { key: "state", label: "State", type: "text", length: 2 },
  { key: "zip", label: "Zip", type: "text" },
  { key: "customerSince", label: "Customer Since" },
  { key: "taxDetailID", label: "Tax Detail" },
  { key: "paymentID", label: "Payment Terms" },
  { key: "salesID", label: "Sales Rep" },
];

export const customerGeneralInfo = [
  { key: "customerName", label: "Name", type: "text" },
  { key: "managementID", label: "Management ID", type: "text" },
  {
    key: "statusID",
    label: "Status",
    type: "select",
    options: [
      { value: "Active", label: "Active" },
      { value: "Cancelled", label: "Cancelled" },
      { value: "Collection", label: "Collection" },
      { value: "Pending", label: "Pending" },
      { value: "Transferred", label: "Transferred" },
      { value: "Expired", label: "Expired" },
    ],
  },
  {
    key: "customerClass",
    label: "Customer Class",
    type: "select",
    options: [
      { value: "Class 1", label: "Class 1" },
      { value: "Class 2", label: "Class 2" },
      { value: "Class 3", label: "Class 3" },
      { value: "Class 4", label: "Class 4" },
    ],
  },
  {
    key: "taxDetailID",
    label: "Tax Detail",
    type: "select",
  },
  { key: "customerSince", label: "Customer Since", type: "date" },
  { key: "salesID", label: "Sales Rep", type: "select" },
  {
    key: "billingClass",
    label: "Billing Class",
    type: "select",
    options: [
      { value: "Class 1", label: "Class 1" },
      { value: "Class 2", label: "Class 2" },
      { value: "Class 3", label: "Class 3" },
      { value: "Class 4", label: "Class 4" },
    ],
  },
  {
    key: "paymentID",
    label: "Payment Terms",
    type: "select",
  },
];

export const customerComment = [
  { key: "customerNote", label: "Customer Note", type: "textArea" },
];

export const customerAddressInfo = [
  { key: "addressCareOf", label: "Address Care Of", type: "text" },
  { key: "address", label: "Address Line 1", type: "text" },
  { key: "addressTwo", label: "Address Line 2", type: "text" },
  { key: "city", label: "City", type: "text" },
  { key: "state", label: "State", type: "text", length: 2 },
  { key: "zip", label: "Zip", type: "text" },
];

export const customeraletInfo = [
  { key: "customerClass", label: "Customer Class", type: "text" },
  { key: "creditLimit", label: "Credit Limit", type: "number" },
  { key: "paymentRating", label: "Payment Rating", type: "number" },
  { key: "averageDaysToPay", label: "Average Days To Pay", type: "number" },
  {
    key: "averageDaysToPayLast",
    label: "Average Days To Pay Last",
    type: "number",
  },
  {
    key: "averageDaysToPayLastYear",
    label: "Average Days To Pay Last Year",
    type: "number",
  },
];

export const customerBillingInfo = [
  { key: "billingAddressCareOf", label: "Address Care Of", type: "text" },
  { key: "billingAddress", label: "Address Line 1", type: "text" },
  { key: "billingAddressTwo", label: "Address Line 2", type: "text" },
  { key: "billingCity", label: "City", type: "text" },
  { key: "billingState", label: "State", type: "text", length: 2 },
  { key: "billingZip", label: "Zip", type: "text" },
];

export const customerSalesInfo = [
  {
    key: "salesIndexMaintenance",
    label: "Sales Index Maintenance",
    type: "number",
  },
  { key: "salesIndexParts", label: "Sales Index Parts", type: "number" },
  { key: "salesIndexProposal", label: "Sales Index Proposal", type: "number" },
  { key: "salesIndexService", label: "Sales Index Service", type: "number" },
];

export const customerPaymentInfo = [
  { key: "paymentRating", label: "Payment Rating", type: "number" },
  { key: "averageDaysToPay", label: "Average Days To Pay", type: "number" },
  {
    key: "averageDaysToPayLast",
    label: "Average Days To Pay Last",
    type: "number",
  },
  {
    key: "averageDaysToPayLastYear",
    label: "Average Days To Pay Last Year",
    type: "number",
  },
];

export const customerAdditionalInfo = [
  {
    key: "dispatchType",
    label: "Dispatch Type",
    type: "select",
    options: [
      { value: "Dispatch Hold", label: "Dispatch Hold" },
      { value: "Open Order", label: "Open Order" },
      { value: "Pending", label: "Pending" },
      { value: "Service Account", label: "Service Account" },
      { value: "Under Contract", label: "Under Contract" },
    ],
  }, // 0-4,  Dispatch Hold, Open Order, Pending, Service Account, Under Contract
  {
    key: "dispatchingStatus",
    label: "Dispatching Status",
    type: "select",
    options: [
      { value: "Dispatch", label: "Dispatch" },
      { value: "Check with Manager", label: "Check with Manager" },
      { value: "Dispatch Hold", label: "Dispatch Hold" },
    ],
  }, // 0-3, Dispatch, Check with Manager, Dispatch Hold
  { key: "websiteAddress", label: "Website Address", type: "text" },
  {
    key: "thirdPartyControlNumber",
    label: "Third Party Control Number",
    type: "text",
  },
  { key: "emailAddress", label: "Email Address", type: "text" },
  { key: "customerNote", label: "Customer Note", type: "text" },
];

export const ContactTitles = [
  { key: "mainContact", label: "Main Contact" },
  { key: "agentContact", label: "Agent Contact" },
  { key: "collectionsContact", label: "Collections Contact" },
];

export const newContactFields = [
  {
    key: "contactName",
    label: "Contact Name",
    type: "text",
  },
  {
    key: "contactTitle",
    label: "Contact Title",
    type: "text",
  },
  {
    key: "description",
    label: "Description",
    type: "text",
  },
  {
    key: "phone1",
    label: "Primary Phone",
    type: "text",
  },
  {
    key: "phone2",
    label: "Secondary Phone",
    type: "text",
  },
  {
    key: "faxNumber",
    label: "Fax Number",
    type: "text",
  },
  {
    key: "emailAddress",
    label: "Email Address",
    type: "text",
  },
  {
    key: "cellPhone",
    label: "Cell Phone",
    type: "text",
  },
  {
    key: "cellPhone2",
    label: "Secondary Cell Phone",
    type: "text",
  },
  {
    key: "emailAddress2",
    label: "Secondary Email Address",
    type: "text",
  },
];

export const defaultContactForm = {
  contactName: "",
  contactTitle: "",
  description: "",
  source: 2, // default can be null or 0 if "Internal" is the default selection
  phone1: "",
  phone2: "",
  faxNumber: "",
  emailAddress: "",
  cellPhone: "",
  cellPhone2: "",
  emailAddress2: "",
  contactLevel: 2, // default can be null or 0 if "Primary" is the default selection
};

export const newBuildingFields = [
  {
    key: "buildingReference",
    label: "Building Reference",
    type: "text",
  },
  {
    key: "buildingNote",
    label: "Building Note",
    type: "text",
  },
  {
    key: "location",
    label: "Location",
    type: "text",
  },
  {
    key: "buildingType",
    label: "Building Type",
    type: "select",
    options: [
      { value: "Standard", label: "Standard" },
      { value: "Priority", label: "Priority" },
      { value: "Emergency", label: "Emergency" },
    ],
    map: {
      Standard: "Standard",
      Priority: "Priority",
      Emergency: "Emergency",
    },
  },
];

export const defaultBuildingForm = {
  // buildingSite: '',
  buildingID: null,
  customerID: null,
  buildingReference: "",
  buildingNote: "",
  location: "",
  buildingType: null,
};

export const buildingTableFields = [
  { key: "buildingReference", label: "Building Reference", type: "text" },
  { key: "buildingNote", label: "Building Note", type: "text" },
  { key: "location", label: "Location", type: "text" },
  {
    key: "buildingType",
    label: "Building Type",
    type: "select",
    options: [
      { value: "Commercial", label: "Commercial" },
      { value: "Company/Office", label: "Company/Office" },
      { value: "Garage", label: "Garage" },
      { value: "Government", label: "Government" },
      { value: "Hospital", label: "Hospital" },
      { value: "Nursing Home", label: "Nursing Home" },
      { value: "Other", label: "Other" },
      { value: "Parent Location", label: "Parent Location" },
      { value: "Religious Facility", label: "Religious Facility" },
      { value: "Residential", label: "Residential" },
      { value: "Restaurant", label: "Restaurant" },
      { value: "School", label: "School" },
      { value: "Ship", label: "Ship" },
      { value: "Transportation Facility", label: "Transportation Facility" },
    ],
    map: {
      Commercial: "Commercial",
      "Company/Office": "Company/Office",
      Garage: "Garage",
      Government: "Government",
      Hospital: "Hospital",
      "Nursing Home": "Nursing Home",
      Other: "Other",
      "Parent Location": "Parent Location",
      "Religious Facility": "Religious Facility",
      Residential: "Residential",
      Restaurant: "Restaurant",
      School: "School",
      Ship: "Ship",
      "Transportation Facility": "Transportation Facility",
    },
  },
  {
    key: "buildingStatus",
    label: "Building Status",
    type: "select",
    options: [
      { value: "Active", label: "Active" },
      { value: "Cancelled", label: "Cancelled" },
      { value: "Collection", label: "Collection" },
      { value: "Pending", label: "Pending" },
      { value: "Transferred", label: "Transferred" },
      { value: "Expired", label: "Expired" },
    ],
    map: {
      Active: "Active",
      Cancelled: "Cancelled",
      Collection: "Collection",
      Pending: "Pending",
      Transferred: "Transferred",
      Expired: "Expired",
    },
  },
];

export const buildingTypes = {
  map: {
    Commercial: "Commercial",
    "Company/Office": "Company/Office",
    Garage: "Garage",
    Government: "Government",
    Hospital: "Hospital",
    "Nursing Home": "Nursing Home",
    Other: "Other",
    "Parent Location": "Parent Location",
    "Religious Facility": "Religious Facility",
    Residential: "Residential",
    Restaurant: "Restaurant",
    School: "School",
    Ship: "Ship",
    "Transportation Facility": "Transportation Facility",
  },
  options: [
    { value: "Commercial", label: "Commercial" },
    { value: "Company/Office", label: "Company/Office" },
    { value: "Garage", label: "Garage" },
    { value: "Government", label: "Government" },
    { value: "Hospital", label: "Hospital" },
    { value: "Nursing Home", label: "Nursing Home" },
    { value: "Other", label: "Other" },
    { value: "Parent Location", label: "Parent Location" },
    { value: "Religious Facility", label: "Religious Facility" },
    { value: "Residential", label: "Residential" },
    { value: "Restaurant", label: "Restaurant" },
    { value: "School", label: "School" },
    { value: "Ship", label: "Ship" },
    { value: "Transportation Facility", label: "Transportation Facility" },
  ],
};

export const status = {
  map: {
    Active: "Active",
    Cancelled: "Cancelled",
    Collection: "Collection",
    Pending: "Pending",
    Transferred: "Transferred",
    Expired: "Expired",
  },
  options: [
    { value: "Active", label: "Active" },
    { value: "Cancelled", label: "Cancelled" },
    { value: "Collection", label: "Collection" },
    { value: "Pending", label: "Pending" },
    { value: "Transferred", label: "Transferred" },
    { value: "Expired", label: "Expired" },
  ],
};

export const customerInfoWithoutMgmt = [
  { key: "customerName", label: "Name", type: "text" },
  {
    key: "statusID",
    label: "Status",
    type: "select",
    options: [
      { value: "Active", label: "Active" },
      { value: "Cancelled", label: "Cancelled" },
      { value: "Collection", label: "Collection" },
      { value: "Pending", label: "Pending" },
      { value: "Transferred", label: "Transferred" },
      { value: "Expired", label: "Expired" },
    ],
  },
  {
    key: "customerClass",
    label: "Customer Class",
    type: "select",
    options: [
      { value: "Class 1", label: "Class 1" },
      { value: "Class 2", label: "Class 2" },
      { value: "Class 3", label: "Class 3" },
      { value: "Class 4", label: "Class 4" },
    ],
  },
  {
    key: "taxDetailID",
    label: "Tax Detail ID",
    type: "text",
  },
  { key: "customerSince", label: "Customer Since", type: "date" },
  { key: "salesID", label: "Sales Rep", type: "text" },
  {
    key: "billingClass",
    label: "Billing Class",
    type: "select",
    options: [
      { value: "Class 1", label: "Class 1" },
      { value: "Class 2", label: "Class 2" },
      { value: "Class 3", label: "Class 3" },
      { value: "Class 4", label: "Class 4" },
    ],
  },
  {
    key: "paymentID",
    label: "Payment Terms ID",
    type: "text",
  },
  {
    key: "customerNotes",
    label: "Notes",
    type: "text",
  },
];
